import ContentLoader from "react-content-loader";

interface Props {
    type?: string;
}

const VerticalNewsLoader = (props: Props) => {
    return (

        <>
            {props.type === 'reverse' ?
                <ContentLoader
                    speed={2}
                    width={'100%'}
                    height={125}
                    // viewBox="0 0 476 124"
                    backgroundColor="#C2C2C2"
                    foregroundColor="#ecebeb"
                >
                    <rect x="1%" y="16" rx="0" ry="0" width="65%" height="20" />
                    <rect x="1%" y="56" rx="0" ry="0" width="65%" height="20" />
                    <rect x="70%" y="16" rx="0" ry="0" width="30%" height="100%" />
                    <rect x="1%" y="88" rx="0" ry="0" width="5%" height="20" />
                    <rect x="10%" y="88" rx="0" ry="0" width="15%" height="20" />
                </ContentLoader>
                :
                <ContentLoader
                    speed={2}
                    width={'100%'}
                    height={124}
                    // viewBox="0 0 476 124"
                    backgroundColor="#C2C2C2"
                    foregroundColor="#ecebeb"
                    {...props}
                >
                    <rect x="1%" y="16" rx="0" ry="0" width="30%" height="100%" />
                    <rect x="40%" y="16" rx="0" ry="0" width="65%" height="20" />
                    <rect x="40%" y="56" rx="0" ry="0" width="65%" height="20" />
                    <rect x="40%" y="88" rx="0" ry="0" width="5%" height="20" />
                    <rect x="50%" y="88" rx="0" ry="0" width="15%" height="20" />
                </ContentLoader>
            }

        </>
    )
}

export default VerticalNewsLoader

